import { ErrorPage } from "@/components/Error/ErrorPage";
import { useConfig } from "@/providers/config/useConfig";

import { Layout } from "./Layout";

export function AddAdminPage(): React.ReactNode {
  const isAdminMultiProjectsInviteAvailable = useConfig("isAdminMultiProjectsInviteAvailable");

  if (!isAdminMultiProjectsInviteAvailable) {
    return <ErrorPage status={404} />;
  }

  return <Layout />;
}
